/* Offering page (template-offering.php). All components guard on their own
   element, so this file is inert on every other page that loads the home-v2
   bundle. Spec: docs/superpowers/specs/2026-08-13-offering-page-template-design.md */
(function () {
  'use strict';

  var root = document.getElementById('pe-offering');
  if (!root) { return; }

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hexToRgb(hex) {
    var h = (hex || '').replace('#', '');
    if (h.length === 3) { h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; }
    var n = parseInt(h, 16);
    if (isNaN(n) || h.length !== 6) { return { r: 25, g: 80, b: 84 }; } /* #195054 fallback */
    return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
  }

  /* ── hero: org-fabric canvas (ported from reference draft, brand-recolored) ── */
  (function () {
    var cv = document.getElementById('ofFabric');
    if (!cv) { return; }
    var ctx = cv.getContext('2d');
    var brand = hexToRgb(cv.dataset.brand);
    var brandA = function (a) { return 'rgba(' + brand.r + ',' + brand.g + ',' + brand.b + ',' + a.toFixed(3) + ')'; };
    var W = 0, H = 0, DPR = Math.min(window.devicePixelRatio || 1, 2);
    var LAYERS = 6, PER = [5, 7, 8, 7, 6, 5];
    var nodes = [], t = 0, lastShuffle = 0;

    function size() {
      var r = cv.getBoundingClientRect();
      W = r.width; H = r.height;
      cv.width = W * DPR; cv.height = H * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      place(true);
    }
    function slot(l, i, n) {
      var padY = H * 0.10, padX = W * 0.10;
      return { x: padX + (W - 2 * padX) * ((i + 0.5) / n), y: padY + (H - 2 * padY) * (l / (LAYERS - 1)) };
    }
    function place(init) {
      if (init) { nodes = []; }
      var k = 0;
      for (var l = 0; l < LAYERS; l++) {
        var n = PER[l], order = [], a, b, i;
        for (i = 0; i < n; i++) { order.push(i); }
        for (a = order.length - 1; a > 0; a--) {
          b = Math.floor(Math.random() * (a + 1));
          if (Math.random() < 0.45) { var tmp = order[a]; order[a] = order[b]; order[b] = tmp; }
        }
        for (i = 0; i < n; i++) {
          var p = slot(l, order[i], n);
          if (init) {
            nodes.push({ l: l, x: p.x, y: p.y, tx: p.x, ty: p.y, ph: Math.random() * Math.PI * 2,
              amp: 4 + Math.random() * 7, r: 1.6 + Math.random() * 1.6, accent: Math.random() < 0.10 });
          } else { nodes[k].tx = p.x; nodes[k].ty = p.y; }
          k++;
        }
      }
    }
    function draw() {
      ctx.clearRect(0, 0, W, H);
      t += 0.0045;
      var i, j, n;
      for (i = 0; i < nodes.length; i++) { n = nodes[i]; n.x += (n.tx - n.x) * 0.012; n.y += (n.ty - n.y) * 0.012; }
      ctx.lineWidth = 1;
      for (i = 0; i < nodes.length; i++) {
        var A = nodes[i];
        var ax = A.x + Math.sin(t * 1.1 + A.ph) * A.amp, ay = A.y + Math.cos(t * 0.8 + A.ph) * A.amp * 0.45;
        for (j = i + 1; j < nodes.length; j++) {
          var B = nodes[j];
          if (B.l - A.l !== 1) { continue; }
          var bx = B.x + Math.sin(t * 1.1 + B.ph) * B.amp, by = B.y + Math.cos(t * 0.8 + B.ph) * B.amp * 0.45;
          var d = Math.abs(ax - bx), reach = W * 0.16;
          if (d > reach) { continue; }
          ctx.strokeStyle = brandA((1 - d / reach) * 0.30);
          ctx.beginPath(); ctx.moveTo(ax, ay); ctx.lineTo(bx, by); ctx.stroke();
        }
        if (i === 0 || nodes[i - 1].l !== A.l) {
          ctx.strokeStyle = brandA(0.10);
          ctx.beginPath(); ctx.moveTo(W * 0.04, A.y); ctx.lineTo(W * 0.97, A.y); ctx.stroke();
        }
      }
      for (i = 0; i < nodes.length; i++) {
        n = nodes[i];
        var x = n.x + Math.sin(t * 1.1 + n.ph) * n.amp, y = n.y + Math.cos(t * 0.8 + n.ph) * n.amp * 0.45;
        var pulse = 0.55 + 0.45 * Math.sin(t * 1.6 + n.ph);
        if (n.accent) {
          ctx.fillStyle = 'rgba(248,109,61,' + (0.45 + 0.35 * pulse).toFixed(3) + ')'; /* #f86d3d */
          ctx.beginPath(); ctx.arc(x, y, n.r + 0.5, 0, Math.PI * 2); ctx.fill();
        } else {
          ctx.fillStyle = brandA(0.28 + 0.30 * pulse);
          ctx.beginPath(); ctx.arc(x, y, n.r, 0, Math.PI * 2); ctx.fill();
        }
      }
      if (!REDUCED && performance.now() - lastShuffle > 9000) { lastShuffle = performance.now(); place(false); }
      if (!REDUCED) { requestAnimationFrame(draw); }
    }
    size();
    lastShuffle = performance.now();
    draw();
    var rz;
    window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { size(); if (REDUCED) { draw(); } }, 180); });
  })();

  /* ── capabilities: scroll-driven panel switch (ported from reference) ── */
  (function () {
    var scroller = document.getElementById('ofCapScroll');
    var idx = document.getElementById('ofCapIndex');
    var prog = document.getElementById('ofCapProg');
    if (!scroller || !idx) { return; }
    var panels = document.querySelectorAll('.of-cap-panel');
    var rows = idx.querySelectorAll('li');
    var N = Math.max(1, parseInt(scroller.dataset.count, 10) || rows.length);
    var current = 0, locked = false, lockT;

    function activate(i) {
      current = i;
      var k;
      for (k = 0; k < rows.length; k++) { rows[k].classList.toggle('on', k === i); }
      for (k = 0; k < panels.length; k++) { panels[k].classList.toggle('on', k === i); }
    }
    function onScroll() {
      if (window.innerWidth <= 900) { return; }
      var r = scroller.getBoundingClientRect();
      var span = scroller.offsetHeight - window.innerHeight;
      if (span <= 0) { return; }
      var p = Math.min(Math.max(-r.top / span, 0), 1);
      if (prog) { prog.style.width = (p * 100).toFixed(1) + '%'; }
      if (locked) { return; }
      var i = Math.min(N - 1, Math.floor(p * N));
      if (i !== current) { activate(i); }
    }
    Array.prototype.forEach.call(rows, function (row) {
      row.querySelector('button').addEventListener('click', function () {
        var i = +this.dataset.i;
        activate(i);
        locked = true; clearTimeout(lockT); lockT = setTimeout(function () { locked = false; }, 900);
        var span = scroller.offsetHeight - window.innerHeight;
        var top = scroller.offsetTop + span * ((i + 0.45) / N);
        window.scrollTo({ top: top, behavior: REDUCED ? 'auto' : 'smooth' });
      });
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  })();

  /* ── principles: spine reveal ── */
  (function () {
    var spine = document.getElementById('ofSpine');
    if (!spine) { return; }
    if (REDUCED || !('IntersectionObserver' in window)) { spine.classList.add('lit'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { spine.classList.add('lit'); io.disconnect(); } });
    }, { threshold: 0.4 });
    io.observe(spine);
  })();
})();
